module.exports = __webpack_public_path__ + "static/media/auction-notif.4d0c8131.mp3";